import { createContext } from "react";

// @TODO: Add types
export const BaseContext = createContext<{[key: string]: any}>({});
